import { render } from "./SelectItems.vue?vue&type=template&id=33b5d50d&scoped=true&ts=true"
import script from "./SelectItems.vue?vue&type=script&lang=ts"
export * from "./SelectItems.vue?vue&type=script&lang=ts"

import "./SelectItems.vue?vue&type=style&index=0&id=33b5d50d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b5d50d"]])

export default __exports__